import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "aws-amplify";
import { Utils } from "../../utils/utils";
import { SNACKBAR_MESSAGE } from "../../components/SnackbarsHandler";
import { useSnackbars } from "../../hooks/use-snackbars";
import { FormattedMessage } from "react-intl";
import { KTSVG } from "../../../_metronic/helpers";

export const DownloadSignaturePage: FC = () => {
  const { signatureId } = useParams();
  const { createSnackbar } = useSnackbars();
  const [isDownloading, setIsDownloading] = useState(true);

  useEffect(() => {
    const downloadSignature = () => {
      API.get("API", `/signatures/${signatureId}/download`, {})
        .then((response) => {
          Utils.downloadFile(
            response.documentUrl,
            response.signatureTitle || response.documentName
          );
          setIsDownloading(false);
        })
        .catch(() => {
          createSnackbar(SNACKBAR_MESSAGE.DANGER.DOWNLOAD_FILE);
        });
    };

    if (signatureId) {
      downloadSignature();
    }
  }, [signatureId, createSnackbar]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
      {isDownloading ? (
        <>
          <div className="spinner-border text-primary mb-4" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h2 className="mb-4">
            <FormattedMessage id="GLOBAL.DOWNLOAD_PREPARE" />
          </h2>
        </>
      ) : (
        <>
          <KTSVG
            path="/media/icons/duotune/files/fil025.svg"
            className="svg-icon-success mb-4"
            svgClassName="h-100px w-100px"
          />
          <h2 className="mb-4">
            <FormattedMessage id="GLOBAL.DOWNLOAD_STARTED" />
          </h2>
        </>
      )}
    </div>
  );
};
